import { Link } from "react-router-dom";

export const Footer = () => (
  <footer data-testid="main-footer" className="border-t border-white/10 bg-coal">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid md:grid-cols-3 gap-12">
      <div>
        <p className="font-syne font-extrabold text-2xl uppercase tracking-tighter mb-4">
          TWELVE <span className="text-blood">12</span> SHOP
        </p>
        <p className="text-smoke text-sm leading-relaxed max-w-xs">
          Streetwear technique & sneakers en édition limitée. Conçu dans l'ombre, porté sous les néons.
        </p>
      </div>
      <div className="font-mono text-xs uppercase tracking-[0.2em] space-y-3">
        <p className="text-ash mb-4">Navigation</p>
        <Link to="/" className="block text-smoke hover:text-white transition-colors">Accueil</Link>
        <Link to="/boutique" className="block text-smoke hover:text-white transition-colors">Boutique</Link>
        <Link to="/contact" data-testid="footer-contact-link" className="block text-smoke hover:text-white transition-colors">Nous contacter</Link>
        <Link to="/admin/login" className="block text-smoke hover:text-white transition-colors">Espace admin</Link>
      </div>
      <div className="font-mono text-xs uppercase tracking-[0.2em] space-y-3">
        <p className="text-ash mb-4">Infos</p>
        <p className="text-smoke">Île-de-France : livraison 24h</p>
        <p className="text-smoke">France : 2-3 jours ouvrés</p>
        <p className="text-smoke">Hors France : 5-10 jours ouvrés</p>
        <p className="text-smoke">Livraison offerte dès 150 €</p>
        <p className="text-smoke">Paiement sécurisé Stripe</p>
        <a
          href="mailto:twelveshop669contact@gmail.com"
          data-testid="footer-contact-email"
          className="inline-flex items-center gap-2 text-volt hover:text-white transition-colors normal-case tracking-normal font-medium mt-2"
        >
          twelveshop669contact@gmail.com
        </a>
      </div>
    </div>
    <div className="border-t border-white/10 py-6 text-center font-mono text-[10px] uppercase tracking-[0.3em] text-ash">
      © 2026 TWELVE 12-SHOP — No Conformity
    </div>
  </footer>
);
